"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.user = void 0;
const axios_1 = __importDefault(require("axios"));
const immer_1 = require("immer");
const store_1 = require("../../../../exports/store");
const initValue = {
    info: null,
    isLogin: false,
    isRegister: false,
    isCreateSpace: false,
    err: null,
    loading: false,
    // http request status
    reqStatus: false,
    httpErrInfo: null,
    userInfoErr: null,
    activeRecordId: null,
};
const userInfo = (typeof window === 'object' &&
    window.__initialization_data__ &&
    window.__initialization_data__.userInfo) || null;
if (userInfo) {
    axios_1.default.defaults.headers.common['X-Space-Id'] = userInfo.spaceId;
}
const defaultValue = {
    info: userInfo,
    isLogin: Boolean(userInfo),
    isRegister: false,
    isCreateSpace: false,
    err: null,
    loading: !userInfo,
    // http request status
    reqStatus: false,
    httpErrInfo: null,
    userInfoErr: null,
    activeRecordId: null,
};
exports.user = (0, immer_1.produce)((userDraft = defaultValue, action) => {
    switch (action.type) {
        case store_1.ActionConstants.SET_USER_ME: {
            userDraft.info = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SET_IS_LOGIN: {
            userDraft.isLogin = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SET_HOME_ERR: {
            userDraft.err = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SET_REGISTER_STATUS: {
            userDraft.isRegister = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SET_USED_INVITE_REWARD: {
            if (userDraft.info) {
                userDraft.info.usedInviteReward = action.payload;
            }
            return userDraft;
        }
        case store_1.ActionConstants.SET_LOADING: {
            userDraft.loading = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SET_USER_AVATAR: {
            userDraft.info.avatar = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SET_USER_AVATAR_COLOR: {
            userDraft.info.avatarColor = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SET_USER_TIMEZONE: {
            userDraft.info.timeZone = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SIGN_OUT: {
            return initValue;
        }
        case store_1.ActionConstants.SET_REQ_STATUS: {
            userDraft.reqStatus = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SET_HTTP_ERR_INFO: {
            userDraft.httpErrInfo = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.SET_NICKNAME: {
            userDraft.info.nickName = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.UPDATE_USERINFO: {
            userDraft.info = Object.assign({}, userDraft.info, action.payload);
            return userDraft;
        }
        case store_1.ActionConstants.UPDATE_USERINFO_ERR: {
            userDraft.userInfoErr = action.payload;
            return userDraft;
        }
        case store_1.ActionConstants.ADD_WIZARD_NUMBER: {
            const wizardId = action.payload;
            if (userDraft.info && wizardId in userDraft.info.wizards) {
                userDraft.info.wizards[wizardId]++;
                return userDraft;
            }
            if (userDraft.info && !(wizardId in userDraft.info.wizards)) {
                userDraft.info.wizards[wizardId] = 1;
                return userDraft;
            }
            return userDraft;
        }
        case store_1.ActionConstants.SET_ACTIVE_RECORD_ID: {
            userDraft.activeRecordId = action.payload;
            return userDraft;
        }
        default:
            return userDraft;
    }
}, defaultValue);
//# sourceMappingURL=user.js.map